export default {
  display: true,
  title: "Sidely",
  contentType: "menu",
  canReduce: true,
  search: false,
  content: [
    {
      label: "Commandes By Terry",
      icon: "rdv",
      id: "orderbyterry",
      component: "",
      path: "/byterry/commandes",
      onClick: "",
      minRole: 1
    },
    {
      label: "Evenenement Haleon Pharma",
      icon: "rdv",
      id: "eventhaleon",
      component: "",
      path: "/haleon/event",
      onClick: "",
      minRole: 1
    }
  ]
};



// WEBPACK FOOTER //
// src/pages/sidely/Menu.js